import { render, staticRenderFns } from "./custom_notifications_modal.vue?vue&type=template&id=5902705c&vue3"
import script from "./custom_notifications_modal.vue?vue&type=script&lang=js&vue3"
export * from "./custom_notifications_modal.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports